import { cloneDeep } from 'lodash-es';

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
const reducer = (state, action) => {
  try {
    const { type } = action;
    const newState = cloneDeep(state);

    switch (type) {
      case '':
        break;
      default:
        // eslint-disable-next-line no-console
        console.error(`Unexpected action`);
        return state;
    }

    return newState;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`reducer: ${e.stack}`);
  }
  return state;
};

export default reducer;
